var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "setting-main-container" }, [
    _c(
      "form",
      {
        attrs: { action: "" },
        on: {
          submit: function ($event) {
            $event.preventDefault()
            return _vm.submitCustomerData($event)
          },
        },
      },
      [
        _c("div", { staticClass: "card setting-card" }, [
          _c("div", { staticClass: "page-header" }, [
            _c("h3", { staticClass: "page-title" }, [
              _vm._v(_vm._s(_vm.$t("general.credit_details"))),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row  mb-4" }, [
            _c("div", { staticClass: "col-md-6 mb-6" }, [
              _c("label", { staticClass: "input-label" }, [
                _vm._v(_vm._s(_vm.$tc("general.credit_limit"))),
              ]),
              _c("span", { staticClass: "text-danger" }, [_vm._v(" * ")]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "base-input" },
                [
                  _c(
                    "money",
                    _vm._b(
                      {
                        staticClass: "input-field",
                        class: { invalid: _vm.$v.formData.credit_limit.$error },
                        model: {
                          value: _vm.formData.credit_limit,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "credit_limit", $$v)
                          },
                          expression: "formData.credit_limit",
                        },
                      },
                      "money",
                      _vm.customerCurrency,
                      false
                    )
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.$v.formData.credit_limit.$error
                ? _c("div", [
                    !_vm.$v.formData.credit_limit.minValue
                      ? _c(
                          "span",
                          { staticClass: "form-group__message text-danger" },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "validation.enter_credit_greater_than_used_credit"
                                )
                              )
                            ),
                          ]
                        )
                      : _vm._e(),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-6 mb-6" }, [
              _c("label", { staticClass: "input-label" }, [
                _vm._v(_vm._s(_vm.$tc("general.used_credit"))),
              ]),
              _c("span", { staticClass: "text-danger" }, [_vm._v(" * ")]),
              _vm._v(" "),
              _c("div", { staticClass: "base-read-box base-read-box-field" }, [
                _c("div", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$utils.formatMoney(
                        _vm.used_credit,
                        _vm.customerCurrencyViewFormat
                      )
                    ),
                  },
                }),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row mb-4" }, [
            _c(
              "div",
              { staticClass: "col-md-6 mb-6" },
              [
                _c("label", { staticClass: "input-label" }, [
                  _vm._v(_vm._s(_vm.$t("general.starting_date"))),
                  _c("span", { staticClass: "text-danger" }, [_vm._v(" * ")]),
                ]),
                _vm._v(" "),
                _c("base-date-picker", {
                  attrs: {
                    "calendar-button": true,
                    "calendar-button-icon": "calendar",
                  },
                  on: {
                    change: function ($event) {
                      return _vm.$v.formData.starting_date.$touch()
                    },
                  },
                  model: {
                    value: _vm.formData.starting_date,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "starting_date", $$v)
                    },
                    expression: "formData.starting_date",
                  },
                }),
                _vm._v(" "),
                _vm.$v.formData.starting_date.$error &&
                !_vm.$v.formData.starting_date.required
                  ? _c("span", { staticClass: "text-danger" }, [
                      _vm._v(" " + _vm._s(_vm.$t("validation.required")) + " "),
                    ])
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-md-6 mb-6" },
              [
                _c("label", { staticClass: "input-label" }, [
                  _vm._v(_vm._s(_vm.$t("general.renewal_date"))),
                  _c("span", { staticClass: "text-danger" }, [_vm._v(" * ")]),
                ]),
                _vm._v(" "),
                _c("base-date-picker", {
                  attrs: {
                    "calendar-button": true,
                    "calendar-button-icon": "calendar",
                  },
                  on: {
                    change: function ($event) {
                      return _vm.$v.formData.renewal_date.$touch()
                    },
                  },
                  model: {
                    value: _vm.formData.renewal_date,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "renewal_date", $$v)
                    },
                    expression: "formData.renewal_date",
                  },
                }),
                _vm._v(" "),
                _vm.$v.formData.renewal_date.$error &&
                !_vm.$v.formData.renewal_date.required
                  ? _c("span", { staticClass: "text-danger" }, [
                      _vm._v(" " + _vm._s(_vm.$t("validation.required")) + " "),
                    ])
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row mb-4" }, [
            _c(
              "div",
              { staticClass: "col-md-6 mb-6" },
              [
                _c("label", { staticClass: "input-label" }, [
                  _vm._v(_vm._s(_vm.$t("general.type_of_credit"))),
                  _c("span", { staticClass: "text-danger" }, [_vm._v(" * ")]),
                ]),
                _vm._v(" "),
                _c("base-select", {
                  class: { error: _vm.$v.formData.type_of_credit.$error },
                  attrs: {
                    options: _vm.CreditTypes,
                    searchable: true,
                    "show-labels": false,
                    "allow-empty": false,
                    placeholder: _vm.$t("general.type_of_credit"),
                  },
                  model: {
                    value: _vm.formData.type_of_credit,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "type_of_credit", $$v)
                    },
                    expression: "formData.type_of_credit",
                  },
                }),
                _vm._v(" "),
                _vm.$v.formData.type_of_credit.$error &&
                !_vm.$v.formData.type_of_credit.required
                  ? _c("span", { staticClass: "text-danger" }, [
                      _vm._v(" " + _vm._s(_vm.$t("validation.required")) + " "),
                    ])
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-md-6 mb-6" },
              [
                _c("label", { staticClass: "input-label" }, [
                  _vm._v(_vm._s(_vm.$t("general.type_of_collateral"))),
                  _c("span", { staticClass: "text-danger" }, [_vm._v(" * ")]),
                ]),
                _vm._v(" "),
                _c("base-select", {
                  class: { error: _vm.$v.formData.type_of_collateral.$error },
                  attrs: {
                    options: _vm.CollateralTypes,
                    searchable: true,
                    "show-labels": false,
                    "allow-empty": false,
                    placeholder: _vm.$t("general.type_of_collateral"),
                  },
                  model: {
                    value: _vm.formData.type_of_collateral,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "type_of_collateral", $$v)
                    },
                    expression: "formData.type_of_collateral",
                  },
                }),
                _vm._v(" "),
                _vm.$v.formData.type_of_collateral.$error &&
                !_vm.$v.formData.type_of_collateral.required
                  ? _c("span", { staticClass: "text-danger" }, [
                      _vm._v(" " + _vm._s(_vm.$t("validation.required")) + " "),
                    ])
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row  mb-4" }, [
            _c(
              "div",
              { staticClass: "col-md-12 input-group" },
              [
                _c(
                  "base-button",
                  {
                    attrs: {
                      loading: _vm.isLoading,
                      disabled: _vm.isLoading,
                      icon: "save",
                      color: "theme",
                      type: "submit",
                    },
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$tc("profile.business_status.save")) +
                        "\n          "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }